import {trackLinkEvent} from "../../library/analytics";
import {ga4TrackSimpleEvent} from "../../website/webpack/modules/analytics";


$(document).ready(function () {
    $(document).on('click', '.personalized-service-element', function(e){
        e.stopPropagation();
        let link = $(this).find('a');
        trackLinkEvent('PersonalizedService', 'click', link.text(), link, e);
        ga4TrackSimpleEvent(
            {
                event: 'personalizedservice',
                method: link.data('service')
            }
        );
    });
});